export default {
  postUrl() {
    return 'https://fakestoreapi.com/products'
  },
  putUrl() {
    return 'https://fakestoreapi.com/products/1'
  },
  getUrl() {
    return 'https://fakestoreapi.com/products'
  },
  deleteUrl() {
    return 'https://fakestoreapi.com/products/1'
  },

  parse(raw = {}) {
    return {
      statusCode: raw?.statusCode || 200,
      message: raw?.message || 'KYC operation processed successfully',
      data: raw?.data || null,
    }
  },

  format(payload = {}) {
    return {
      kycOperation: {
        id: payload.id || null,
        userId: payload.userId,
        operationType: payload.operationType, // verify, reject, request_additional, approve
        documentId: payload.documentId || null,
        documentType: payload.documentType, // id_card, passport, residence_proof, etc.
        reason: payload.reason || null,
        notes: payload.notes || '',
        reviewerId: payload.reviewerId,
        reviewerName: payload.reviewerName,
        status: payload.status, // pending, approved, rejected, additional_required
        reviewedAt: payload.reviewedAt || new Date().toISOString(),
      },
      documents: payload.documents || [],
      requirements: {
        additionalDocuments: payload.additionalDocuments || [],
        explanations: payload.explanations || [],
        deadline: payload.deadline || null,
      },
      notifications: {
        sendEmail: payload.sendEmail !== false,
        sendSms: payload.sendSms !== false,
        sendPush: payload.sendPush !== false,
        template: payload.template || 'kyc_status_update',
      },
      compliance: {
        riskLevel: payload.riskLevel || 'low',
        flags: payload.flags || [],
        autoApprove: payload.autoApprove || false,
        requiresManualReview: payload.requiresManualReview !== false,
      },
    }
  },
}
